import { effect, inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services";

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // If auth is not ready yet, wait for it
  if (!auth.isInitialized()) {
    return new Promise(resolve => {
      const effectRef = effect(() => {
        if (auth.isInitialized()) {
          effectRef.destroy();

          resolve(
            auth.isLoggedIn()
              ? true
              : router.createUrlTree(['/auth/login'], {
                  queryParams: { redirectUrl: state.url }
                })
          );
        }
      });
    });
  }

  // Auth already initialized
  return auth.isLoggedIn()
    ? true
    : router.createUrlTree(['/auth/login'], {
        queryParams: { redirectUrl: state.url }
      });
};